import React from 'react'
import { SocialConnect } from '@fs/zion-social'

export default function FooterSocial({ centered = false }) {
  const platforms = {
    facebook: 'https://www.facebook.com/familysearch',
    twitter: 'https://www.twitter.com/familysearch',
    instagram: 'https://www.instagram.com/familysearch',
    youtube: 'https://www.youtube.com/familysearch',
  }
  const analytics = {
    link_page: 'FooterExpansionContent',
    link_app: 'home',
  }

  return (
    <SocialConnect
      platforms={platforms}
      useIconButtons
      alignX={centered ? 'center' : 'end'}
      iconButtonEmphasis="low"
      analytics={analytics}
      color="gray"
    />
  )
}
